/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Gekuendigtzum1Inputs */



/**

* @param {_Field_Gekuendigtzum1Inputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
const _field_gekuendigtzum1 = /** @type {((inputs?: _Field_Gekuendigtzum1Inputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Gekuendigtzum1Inputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return /** @type {LocalizedString} */ ("Gekündigt zum / Befristung")
});
export { _field_gekuendigtzum1 as "_field_gekuendigtZum" }